import { makeObservable } from 'mobx';
import Configuracao from '../../util/Configuracao';
import { Filtro } from './Filtro';
import FiltroOrigem from './FiltroOrigem';

export default class FiltroIncluidoPeloGabinete extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return 'Incluído diretamente na sessão';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        return registro.incluidoPeloGabinete;
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }

    get isHabilitado() {
        return this.store.rootStore.parametroStore.isOrgaoTST && this.store.existeSessaoSIJ;
    }

    preFiltrar(processos) {
        return new FiltroOrigem({ valor: Configuracao.ORIGEM_SIJ }).filtrar(processos);
    }
}
